import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'pledge',
  type: 'node--pledge',
  attributes: {
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    comentariosAnalisis: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'comentarios_analisis',
    },
    direccion: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'direccion',
    },
    folio: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'folio',
    },
    libro: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'libro',
    },
    numeroFinca: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'num_finca',
    },
    registroPropiedad: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'num_registro_propiedad',
    },
    poblacion: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'poblacion',
    },
    referenciaCatastral: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'ref_catastral',
    },
    tomo: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'tomo',
    },
    codigoPostal: {
      type: 'integer',
      required: true,
      isArray: false,
      name: 'codigo_pos',
    },
    m2c: {
      type: 'float',
      required: true,
      isArray: false,
      name: 'm2_calculados',
    },
    m2u: {
      type: 'float',
      required: true,
      isArray: false,
      name: 'm2_utiles',
    },
    importeTasacion: {
      type: 'float',
      required: true,
      isArray: false,
      name: 'importe_cert_tasac',
    },
    viviendaHabitual: {
      type: 'float',
      required: true,
      isArray: false,
      name: 'vivienda_habitual',
    },
  },
  relationships: {
    appraisals: {
      type: 'node--appraisal',
      required: false,
      isArray: true,
      name: 'appraisals',
    },
    burdens: {
      type: 'node--burden',
      required: false,
      isArray: true,
      name: 'burdens',
    },
    distributionPledge: {
      type: 'node--distribution_pledge',
      required: false,
      isArray: false,
      name: 'distribution_pledge',
    },
    owners: {
      type: 'node--owner',
      required: false,
      isArray: true,
      name: 'owners',
    },
    propertyMarket: {
      type: 'node--property_market',
      required: false,
      isArray: false,
      name: 'property_market',
    },
  },
};
export const PledgeService = createService(base, configuration, API_CONFIG.API);
export const PledgeModule = createModule(PledgeService, true);



// WEBPACK FOOTER //
// ./src/models/pledge.js